export const gotoPaymentCheckout = async (
  paymentRequestId: string
) => {
  const checkoutFields = await retrievePaymentCheckout(
    paymentRequestId
  )

  const form = document.createElement("form")
  form.style.display = "none"
  form.action =
    "https://gw1.tponlinepayments.com/hosted/modal/"
  form.method = "post"
  document.body.appendChild(form)
  Object.entries(checkoutFields).forEach(([key, value]) => {
    const input = document.createElement("input")
    input.name = key
    input.value = value
    input.style.display = "none"
    input.type = "hidden"
    form.appendChild(input)
  })

  form.submit()
}
